<template>
  <svg
    role="img"
    :aria-label="title"
    class="o-icon o-site-icon"
    viewBox="0 0 420 420"
    width="40"
    height="40"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      d="M210,415C97.4,415,5.6,323.7,5,211C4.4,98,95.9,5.6,208.9,5h2.1c54.4,0.3,105.5,21.6,144,60s59.8,89.5,60,143.9
		c0.3,54.8-20.8,106.3-59.3,145.3s-89.9,60.5-144.6,60.8C210.7,415,210.3,415,210,415z M220,295.1v99.6c0.4,0,0.9,0,1.3-0.1
		c27.4-27.5,48.3-57.4,62.3-88.7C262.9,299.6,241.5,295.9,220,295.1z M138.9,305.2c13.7,31.1,34.2,60.8,61.1,88.2v-98.3
		C179.4,295.9,158.9,299.3,138.9,305.2z M73.9,335.2c25.3,27.5,58.7,47.3,96.5,55.5c-20.5-23.7-36.9-49.1-48.8-75.6
		c-0.5-1.1-1-2.3-1.5-3.4C104,317.8,88.6,325.6,73.9,335.2z M302.4,312.6c-0.3,0.8-0.7,1.5-1,2.3c-11.9,26.4-28.1,51.6-48.5,75.1
		c33.3-7.9,63.9-24.9,88.6-49.9c1.6-1.6,3.2-3.3,4.7-4.9C332.2,326.1,317.6,318.6,302.4,312.6z M309.8,294
		c17,6.8,33.5,15.3,49.2,25.7c21.4-29,33.8-63.4,35.7-99.7h-70.6C323.1,245,318.3,269.8,309.8,294z M25.3,220
		c2,37.2,15,71.5,35.8,99.7c16.4-10.9,33.7-19.7,51.6-26.6c-8.3-23.9-13-48.3-14.1-73H25.3z M220,275.1c24,0.9,47.9,5,71,12.2
		c7.7-21.9,12.1-44.4,13.1-67.3H220V275.1z M118.7,220c1,22.6,5.3,44.9,12.9,66.5c22.3-6.8,45.4-10.6,68.5-11.4V220H118.7z
		 M324.1,200h70.6c-1.9-35.4-13.9-68.2-33.1-95.6c-16,10.9-32.8,19.8-50.2,26.9C318.9,153.8,323.1,176.8,324.1,200z M220,200h84.1
		c-0.9-21-4.8-41.7-11.4-61.9c-23.6,7.6-48.1,11.8-72.7,12.8V200z M118.6,200H200v-49.2c-23.8-0.9-47.5-4.9-70.4-12
		C123.2,158.8,119.5,179.2,118.6,200z M25.3,200h73.4c0.9-22.9,5-45.6,12.2-67.9c-18.2-7.2-35.9-16.5-52.6-27.8
		C39.1,131.7,27.2,164.6,25.3,200z M220,25.3v105.5c22.2-0.9,44.3-4.7,65.6-11.5c-14-33.3-35.8-65-64.9-94
		C220.5,25.3,220.2,25.3,220,25.3z M136.5,120c20.7,6.4,42.1,10,63.5,10.8V26.1C171.5,55.2,150.2,86.8,136.5,120z M70.6,88.5
		c15,10.1,30.8,18.3,47.1,24.8c1.2-3,2.5-6,3.8-8.9c11.8-26.3,28-51.5,48.3-75C130.6,38.1,96.1,59.3,70.6,88.5z M252.4,29.9
		c20.6,23.7,37.1,49.1,49,75.7c1,2.3,2,4.6,3,6.9c15.5-6.3,30.6-14.3,44.9-23.9C324.2,59.9,290.6,39,252.4,29.9z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'SiteIcon',
  props: {
    title: {
      type: String,
      default: 'Site',
    },
  },
}
</script>
